import { render, staticRenderFns } from "./install-update-dialog.vue?vue&type=template&id=42826054&scoped=true"
import script from "./install-update-dialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./install-update-dialog.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./install-update-dialog.vue?vue&type=style&index=0&id=42826054&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42826054",
  null
  
)

export default component.exports